import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/Modal';
import Select from '../../../../components/Select';
import RadioGroup, { Radio } from '../../../../components/RadioGroup';
import { getShippingCompanies } from '../../../../redux/shipping-company';

import Breadcrumb from './Breadcrumb';
import Form from './Form';

const filters = {
  ALL: 'ALL',
  CUSTOM: 'CUSTOM',
};

class DashboardCompletedFilterShippingCompanyModal extends Component {
  constructor(props) {
    super(props);

    const isCustom = props.selectedShippingCompanies.length > 0;

    this.state = {
      value: props.selectedShippingCompanies || [],
      isCustom,
      selectedFilter: isCustom ? filters.CUSTOM : filters.ALL,
    };
  }

  componentDidMount() {
    this.props.dispatch(getShippingCompanies());
  }

  _changeFilter = (type) => {
    if (type === filters.CUSTOM) {
      this.setState({ isCustom: true });
    } else {
      // ALL
      this.props.onApply([]);
    }
  };

  _handleChange = (value) => {
    this.setState({
      value: value.map(v => v.value),
    });
  };

  _mapListToOptions = () => this.props.shippingCompaniesList.map(shippingCompany => ({
    value: shippingCompany.id,
    label: shippingCompany.ds_RazaoSocial,
  }));

  _submit = () => {
    this.props.onApply(this.state.value);
  };

  _goBack = () => {
    this.setState({ isCustom: false });
  };

  _renderContent = () => {
    const { isCustom, selectedFilter } = this.state;

    if (isCustom) {
      return (
        <div>
          <Breadcrumb
            onBack={this._goBack}
            prev="Todos os filtros"
            current="Selecionar transportadoras"
          />
          <Form onSubmit={this._submit} submitText="Aplicar">
            <Select
              options={this._mapListToOptions()}
              value={this.state.value}
              onChange={this._handleChange}
              closeOnSelect={false}
              multi
            />
          </Form>
        </div>
      );
    }

    return (
      <RadioGroup value={selectedFilter} onChangeValue={this._changeFilter}>
        <Radio value={filters.ALL} label="Todas as transportadoras" />
        <Radio value={filters.CUSTOM} label="Selecionar transportadoras" />
      </RadioGroup>
    );
  };

  render() {
    return (
      <Modal
        title="Selecionar transportadoras"
        size="small"
        onBackdropClick={this.props.onBackdropClick}
      >
        {this._renderContent()}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  shippingCompaniesList: state.shippingCompany.list,
});

export default connect(mapStateToProps)(DashboardCompletedFilterShippingCompanyModal);
